import React, { FC } from "react";
import { Empty } from "antd";

interface ImgDetailProps {
  img: string;
  altText?: string;
}

const ImgDetail: React.FC<ImgDetailProps> = ({ img, altText = "Image" }) => {
  if (!img || img.trim() === "") {
    return <Empty description="Chưa có hình ảnh" />;
  }

  let src = img;

  if (!img.startsWith("data:image")) {
    if (img.startsWith("http") || img.startsWith("/")) {
      src = img;
    } else {
      src = `data:image/png;base64,${img}`;
    }
  }

  return (
    <div style={{ textAlign: "center", margin: "20px" }}>
      <img
        src={src}
        alt={altText}
        style={{
          maxWidth: "100%",
          height: "auto",
          border: "1px solid #ccc",
          borderRadius: "8px",
        }}
      />
    </div>
  );
};

export default ImgDetail;
